export const BooleanLiteral = {
  print: ({ node }) => (node.value ? 'true' : 'false')
};
